import script from "./quick-filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./quick-filters.vue?vue&type=script&setup=true&lang=ts"

import "./quick-filters.vue?vue&type=style&index=0&id=724c098c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724c098c"]])

export default __exports__